// Default risk level for a cell follows the industry-conventional (AS/NZS 4360-heritage) construction: the raw
// product score consequence × probability, binned into the scale's levels by fixed thresholds. Consequence and
// probability are deliberately weighted equally, so the preset is symmetric.
const productLevelLowerBoundsByScale: Record<number, number[]> = {
    3: [1, 3, 6],
    4: [1, 4, 8, 12],
    6: [1, 4, 8, 15, 20, 30],
};

// The 5-scale instead bins the summed score consequence + probability, giving a symmetric distribution with a
// clean 1..5 diagonal that steps up one level per diagonal. This still reserves the top band for the high corner
// — (4,5), (5,4) and (5,5) — and keeps the over-large level-1 region small.
const sumLevelLowerBoundsByScale: Record<number, number[]> = {
    5: [2, 4, 6, 7, 9],
};

export function computeMatrixCell(consequenceLevel: number, probabilityLevel: number, scale: number): number {
    const sumLowerBounds = sumLevelLowerBoundsByScale[scale];
    if (sumLowerBounds !== undefined) {
        const sum = consequenceLevel + probabilityLevel;
        return sumLowerBounds.filter((lowerBound) => sum >= lowerBound).length;
    }

    const product = consequenceLevel * probabilityLevel;
    return productLevelLowerBoundsByScale[scale].filter((lowerBound) => product >= lowerBound).length;
}

export function buildDefaultMatrix(scale: number): number[][] {
    return Array.from({ length: scale }, (_, consequenceIndex) =>
        Array.from({ length: scale }, (_, probabilityIndex) => computeMatrixCell(consequenceIndex + 1, probabilityIndex + 1, scale))
    );
}
